const sizes = {
  smallMargin: 15,
  bigMargin: 30,
  xlMargin: 140,
  mobileSecondMargin: 35,
};

export default sizes;
